import React, { useMemo } from "react";
import { AlertTriangle, CheckCircle2, Circle, Loader2, Users } from "lucide-react";
import { computeTaskStats } from "../utils/taskStats";

const TaskKpiBar = ({ tasks = [], onSelect }) => {
    const stats = useMemo(() => computeTaskStats(tasks), [tasks]);

    const cards = [
        {
            id: "open",
            label: "Open Tasks",
            value: stats.open,
            icon: Circle,
            accent: "#3b82f6",
        },
        {
            id: "progress",
            label: "In Progress",
            value: stats.inProgress,
            icon: Loader2,
            accent: "#f59e0b",
        },
        {
            id: "overdue",
            label: "Overdue",
            value: stats.overdue,
            icon: AlertTriangle,
            accent: "#ef4444",
        },
        {
            id: "completed-today",
            label: "Completed Today",
            value: stats.completedToday,
            icon: CheckCircle2,
            accent: "#10b981",
        },
        {
            id: "workload",
            label: "Team Workload",
            value: stats.workload,
            hint: stats.workloadPeople ? `${stats.workloadPeople} people` : "No assignees",
            icon: Users,
            accent: "#94a3b8",
        },
    ];

    return (
        <div className="task-kpi" role="region" aria-label="Task summary">
            {cards.map(({ id, label, value, hint, icon: Icon, accent }) => (
                <button
                    key={id}
                    type="button"
                    className="task-kpi__card"
                    onClick={() => onSelect?.(id)}
                    style={{ "--kpi-accent": accent }}
                >
                    <span className="task-kpi__icon" aria-hidden>
                        <Icon size={14} />
                    </span>
                    <span className="task-kpi__copy">
                        <span className="task-kpi__label">{label}</span>
                        {hint && <span className="task-kpi__hint">{hint}</span>}
                    </span>
                    <span className="task-kpi__value">{value}</span>
                </button>
            ))}
        </div>
    );
};

export default TaskKpiBar;
